import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let header = document.querySelector('[data-block="header"]');
let headerHeight = header.offsetHeight;

gsap.utils.toArray('.js-mattress-collection-section').forEach((section, i) => {
    const isLastSection = i === gsap.utils.toArray('.js-mattress-collection-section').length - 1;

    ScrollTrigger.create({
        trigger: section,
        pin: isLastSection ? false : true,
        start: `top ${headerHeight}`,
        end: `bottom ${headerHeight}`,
        pinSpacing: false,
        invalidateOnRefresh: true
    });
});
